import React, { useRef, useEffect, useState } from "react";
import SlickSlider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./TestimonialUpdatestyle.css";

import img1 from "../../assets/test1.jpg";
import img2 from "../../assets/test2.jpg";
import img3 from "../../assets/test3.jpg";
import img4 from "../../assets/test4.jpg";

const Slider = SlickSlider.default || SlickSlider;

const ChevronLeft = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <polyline points="15 18 9 12 15 6" />
  </svg>
);

const ChevronRight = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <polyline points="9 18 15 12 9 6" />
  </svg>
);

const baseStatic = [
  { id: 1, img: img4, name: "Dr. Patrika",    instagram: "https://www.instagram.com/p/DP3vdAZD3vP/" },
  { id: 2, img: img3, name: "Aryan Singh",      instagram: "https://www.instagram.com/p/DXZktNZGtiX/" },
  { id: 4, img: img2, name: "music_aryasharma", instagram: "https://www.instagram.com/p/DVljmZVEVUW/" },
  { id: 5, img: img1, name: "Mehreen Sheikh",   instagram: "https://www.instagram.com/p/DS40ZoHjRXH/" },
];

export default function Testimonial({ t }) {
  const sliderRef = useRef(null);
  const [slidesToShow, setSlidesToShow] = useState(5);

  const data = [...baseStatic, ...baseStatic, ...baseStatic];

  useEffect(() => {
    const updateSlides = () => {
      const width = window.innerWidth;
      if (width < 480) setSlidesToShow(2);
      else if (width < 768) setSlidesToShow(3);
      else if (width < 1024) setSlidesToShow(3);
      else if (width < 1400) setSlidesToShow(4);
      else setSlidesToShow(5);
    };

    updateSlides();
    window.addEventListener("resize", updateSlides);
    return () => window.removeEventListener("resize", updateSlides);
  }, []);

  const settings = {
    infinite: true,
    slidesToShow: slidesToShow,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    speed: 800,
    cssEase: "ease-in-out",
    pauseOnHover: true,
    arrows: false,
    dots: false,
    swipe: true,
  };

  return (
    <div style={{position:"relative"}}>

      <h2 className="testimonial-title">
       Trusted By Clients Across Industries
      </h2>
      <p className="testimonial-description">Recommended by entrepreneurs, corporates, and freelancers, our NFC cards create lasting impressions.</p>

      <div className="testimonial-slider">
        <Slider ref={sliderRef} {...settings}>
          {data.map((item, i) => (
            <div key={i}>
              <div className="testimonial-card">
                <img src={item.img} alt={item.name} className="testimonial-card-img" />

                <div className="testimonial-card-overlay">
                  <button
                    onClick={(e) => { e.stopPropagation(); window.open(item.instagram, "_blank", "noopener,noreferrer"); }}
                    className="testimonial-play-btn"
                  >
                    ▶
                  </button>

                  {/* <h4 className="testimonial-card-name">{item.name}</h4> */}
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>

      <div className="testimonial-arrows">
        <button onClick={() => sliderRef.current?.slickPrev()} className="testimonial-arrow-btn">
          <ChevronLeft />
        </button>
        <button onClick={() => sliderRef.current?.slickNext()} className="testimonial-arrow-btn">
          <ChevronRight />
        </button>
      </div>
    </div>
  );
}
